import { render, staticRenderFns } from "./RiskAssessmentAlways.vue?vue&type=template&id=3c9781a9&scoped=true&"
import script from "./RiskAssessmentAlways.vue?vue&type=script&lang=js&"
export * from "./RiskAssessmentAlways.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9781a9",
  null
  
)

export default component.exports